import Link from 'next/link';
import {
  FormValidationCode,
  FormValidationJSCode,
} from './codeHighlights/FormValidationCode';

const FormValidation = () => {
  return (
    <>
      <h1>Form-Validierung</h1>
      <p className="lead">
        Dieses Formular dient als Beispiel für die Validierung mit sämtlichen
        Formelementen wie <code>Text</code>, <code>Select</code>,{' '}
        <code>Checkboxen</code>, <code>Radios</code> und <code>Textarea</code>.
        Das Validierungsskript ist unten aufgeführt und ist im{' '}
        <Link
          href={`${process.env.NEXT_PUBLIC_BASE_URL}/download`}
          legacyBehavior
        >
          <a>Download-Packet</a>
        </Link>{' '}
        enthalten.
      </p>
      <form className="row g-3 needs-validation" noValidate>
        <div className="col-md-4">
          <label htmlFor="validationCustom01" className="form-label">
            First name
          </label>
          <input
            type="text"
            className="form-control"
            id="validationCustom01"
            required
            onChange={e => {}}
          />
          <div id="emailHelp" className="form-text">
            We'll never share your email with anyone else.
          </div>
          <div className="invalid-feedback">Please add your first name!</div>
        </div>
        <div className="col-md-4">
          <label htmlFor="validationCustom02" className="form-label">
            Last name
          </label>
          <input
            type="text"
            className="form-control"
            id="validationCustom02"
            required
            onChange={e => {}}
          />
          <div className="valid-feedback">Looks good!</div>
        </div>
        <div className="col-md-4">
          <label htmlFor="validationCustomUsername" className="form-label">
            Username
          </label>
          <div className="input-group has-validation">
            <span className="input-group-text" id="inputGroupPrepend">
              @
            </span>
            <input
              type="text"
              className="form-control"
              id="validationCustomUsername"
              aria-describedby="inputGroupPrepend"
              required
              onChange={e => {}}
            />
            <div className="invalid-feedback">Please choose a username.</div>
          </div>
        </div>
        <div className="col-md-6">
          <label htmlFor="validationCustom03" className="form-label">
            City
          </label>
          <input
            type="text"
            className="form-control"
            id="validationCustom03"
            required
            onChange={e => {}}
          />
          <div className="invalid-feedback">Please provide a valid city.</div>
        </div>
        <div className="col-md-3">
          <label htmlFor="validationCustom04" className="form-label">
            State
          </label>
          <select className="form-select" id="validationCustom04" required>
            <option defaultValue={''} disabled>
              Choose...
            </option>
            <option>A</option>
            <option>B</option>
            <option>C</option>
          </select>
          <div className="invalid-feedback">Please select a valid state.</div>
        </div>
        <div className="col-md-3">
          <label htmlFor="validationCustom05" className="form-label">
            Zip
          </label>
          <input
            type="text"
            className="form-control"
            id="validationCustom05"
            required
            onChange={e => {}}
          />
          <div className="invalid-feedback">Please provide a valid zip.</div>
        </div>
        <div className="col-12">
          <div className="form-check">
            <input
              className="form-check-input"
              type="checkbox"
              value=""
              id="invalidCheck"
              required
              onChange={e => {}}
            />
            <label className="form-check-label" htmlFor="invalidCheck">
              Agree to terms and conditions
            </label>
            <div className="invalid-feedback">
              You must agree before submitting.
            </div>
          </div>
          <div className="form-check mb-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="validationFormCheck1"
              required
              onChange={e => {}}
            />
            <label className="form-check-label" htmlFor="validationFormCheck1">
              Check this checkbox
            </label>
            <div className="invalid-feedback">
              Example invalid feedback text
            </div>
          </div>

          <div className="form-check">
            <input
              type="radio"
              className="form-check-input"
              id="validationFormCheck2"
              name="radio-stacked"
              required
              onChange={e => {}}
            />
            <label className="form-check-label" htmlFor="validationFormCheck2">
              Toggle this radio
            </label>
          </div>
          <div className="form-check mb-3">
            <input
              type="radio"
              className="form-check-input"
              id="validationFormCheck3"
              name="radio-stacked"
              required
              onChange={e => {}}
            />
            <label className="form-check-label" htmlFor="validationFormCheck3">
              Or toggle this other radio
            </label>
            <div className="invalid-feedback">
              More example invalid feedback text
            </div>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="flexSwitchCheckDefault"
              required
              onChange={e => {}}
            />
            <label
              className="form-check-label"
              htmlFor="flexSwitchCheckDefault"
            >
              Default switch checkbox input
            </label>
          </div>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              id="flexSwitchCheckChecked"
              checked
              onChange={e => {}}
            />
            <label
              className="form-check-label"
              htmlFor="flexSwitchCheckChecked"
            >
              Checked switch checkbox input
            </label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <input
              type="email"
              className="form-control"
              id="floatingInput3"
              placeholder="name@example.com"
              required
            />
            <label htmlFor="floatingInput3">Email address</label>
            <div className="valid-feedback">Looks good!!</div>
            <div className="invalid-feedback">
              Please enter a password. Min. 5 characters required.
            </div>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating">
            <input
              type="password"
              className="form-control"
              id="floatingPassword"
              placeholder="Password"
              autoComplete="on"
              required
            />
            <label htmlFor="floatingPassword">Password</label>
            <div className="valid-feedback">Looks good!!</div>
            <div className="invalid-feedback">
              Please enter a password. Min. 5 characters required.
            </div>
          </div>
        </div>
        <div className="mb-3">
          <label htmlFor="exampleFormControlTextarea1" className="form-label">
            Example textarea
          </label>
          <textarea
            className="form-control"
            id="exampleFormControlTextarea1"
            rows={3}
            required
          ></textarea>
        </div>
        <div className="col-12">
          <button className="btn btn-secondary me-2" type="submit">
            Submit form
          </button>
          <button id="resetForm" className="btn btn-light" type="reset">
            Reset form
          </button>
        </div>
      </form>

      <div className="row mt-5">
        <div className="col-12 col-md-6">
          <FormValidationCode />
        </div>
        <div className="col-12 col-md-6">
          <FormValidationJSCode />
        </div>
      </div>
    </>
  );
};

export default FormValidation;
